import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ExcelExport, ExcelExportColumn } from "@progress/kendo-react-excel-export";
import { useGetZoneCounterList } from "../../../apiclient/transaction/useGetZoneCounterApi";
import EditIcon from "../../../assets/images/edit";
import DeleteIcon from "../../../assets/images/delete";
import { LoadingIndicator } from "../../../core/loading-indicator.component";
import { DeleteModelDialog, DeleteStatus } from "../../../core/delete-model-dialog.component";
import { API_END_POINT } from "../../../constants";
import ZoneCounterModel from "../../../models/transaction/zonecounter-model";
import CardOrderEntryPage from "./cardorder-entry";


const CardOrderPage: React.FC = () => {
    const { data: result, isLoading, isError, refetch: reloadZone } = useGetZoneCounterList();
    const [resultData, setResultData] = useState<any[]>([]);
    const [editModal, setEditModal] = useState<boolean>(false);
    const [editData, setEditdata] = useState<ZoneCounterModel | null>(null);
    const [deleteZoneData, setDeleteZoneData] = useState<any>(null);
    const [searchQuery, setSearchQuery] = useState<string>("");
    const exportExcel = useRef<ExcelExport | null>(null);
    const navigate = useNavigate();
    const [activePage, setActivePage] = useState<"list" | "entry">("list");

    // Group the data by Zone
    const groupDataByZone = (data: ZoneCounterModel[]) => {
        return data.reduce((acc: any[], item: ZoneCounterModel) => {
            const zoneIndex = acc.findIndex(zone => zone.zoneName === item.name);
            if (zoneIndex !== -1) {
                acc[zoneIndex].counters.push(item);
            } else {
                acc.push({ zoneName: item.name, counters: [item] });
            }
            return acc;
        }, []);
    };

    // Filter the data based on the search query
    const filterData = (data: any[], query: string) => {
        if (query) {
            return data.filter((group) =>
                group.zoneName.toLowerCase().includes(query.toLowerCase()) ||
                group.counters.some((counter: any) =>
                    counter.counterName.toLowerCase().includes(query.toLowerCase())
                )
            );
        }
        return data;
    };

    // Effect to set data when result changes
    useEffect(() => {
        if (result) {
            const groupedData = groupDataByZone(result);
            setResultData(groupedData);
        }
    }, [result]);

    /*  const handleEditAgent = (dataItem: ZoneCounterModel) => {
       setEditModal(true);
       setEditdata(dataItem);
     }; */

    const handleDeleteAgent = (dataItem: ZoneCounterModel) => {
        setDeleteZoneData({
            data: dataItem,
            route: `Zone/DeleteZone/${dataItem.zoneId}`,
            endpoint: API_END_POINT.MASTER,
        });
    };

    const onDeleteComplete = (status: DeleteStatus) => {
        if (status === DeleteStatus.Completed) {
            reloadZone();
        }
        setDeleteZoneData(null);
    };

    const excelExport = () => {
        if (exportExcel.current !== null) {
            exportExcel.current.save();
        }
    };

    const onSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchQuery(e.target.value);
    };

    if (isLoading) return <LoadingIndicator isLoading={isLoading} />;
    if (isError) return <div>Error loading data</div>;

    const formatDate = (date: Date): string => {
        const day = date.getDate().toString().padStart(2, '0'); // Ensures two digits
        const month = date.toLocaleString('default', { month: 'short' }); // Gets the abbreviated month name
        const year = date.getFullYear();

        return `${day}-${month}-${year}`;
    };


    const handleEditAgent = (dataItem: any) => {
        const currentDate: Date = new Date();
        //alert(currentDate)
        const formattedDate = formatDate(currentDate);
        const updatedDataItem = { ...dataItem, currentDate: formattedDate };
        //alert(currentDate);
        setEditdata(updatedDataItem);
        //navigate('/ConsumerOrdersEntry', { state: { zoneData: updatedDataItem } });
        // alert("22"+currentDate);
        //console.log("2",updatedDataItem);
        setActivePage("entry"); // switch to entry page on edit

    };
    const handleCancelEntry = () => {
        setEditdata(null);
        setActivePage("list"); // return to list page
    };
    return (
        <div className="card p-3 border-0 m-3 sw-shadow radius-15">
           {/*  <h5 className="text-normal title-web mb-0">Consumer Orders</h5> */}
           <center>
           <h4 className="text-normal title-web mb-0 report-title-color">
                CONSUMER ORDERS
            </h4>
            </center>
            <div className="d-flex mb-3">
            </div>
            {activePage === "entry" && editData ? (
                <CardOrderEntryPage
                    data={editData}
                    onClose={handleCancelEntry}  // closes entry and returns to list
                    setActivePage={setActivePage} // pass setActivePage to handle back button
                />
            ) : (

                <><LoadingIndicator isLoading={isLoading} /><table className="table" style={{ border: "1px solid #ddd", width: "100%" }}>
                    <thead>
                        <tr>
                            <th style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>Zone</th>
                            <th style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>Counter Name</th>
                            <th style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center" }}>Login Users</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filterData(resultData, searchQuery).map((group, index) => (
                            <React.Fragment key={index}>
                                {/* Render Group Header (Zone Name) */}
                                {group.counters.map((counter: any, counterIndex: any) => (
                                    <tr key={counterIndex}>
                                        {counterIndex === 0 ? (
                                            <td style={{ padding: "8px", textAlign: "left", paddingLeft: "200px" }} rowSpan={group.counters.length}>{group.zoneName}</td>
                                        ) : null}
                                        <td style={{
                                            border: "1px solid #ddd", padding: "8px",
                                            textAlign: "left", paddingLeft: "170px"
                                        }}>
                                            <button
                                                className="action-btns k-grid-edit-command"
                                                onClick={() => handleEditAgent(counter)}
                                                style={{
                                                    marginLeft: "10px",
                                                    padding: "5px 10px",
                                                    fontSize: "14px",
                                                    backgroundColor: "#756fe3",
                                                    border: "none",
                                                    borderRadius: "5px",
                                                    color: "#fff",
                                                    cursor: "pointer",
                                                    transition: "background-color 0.3s ease",
                                                }}
                                            >
                                                {counter.counterName}
                                            </button>   </td>

                                        <td style={{ padding: "8px", textAlign: "left", paddingLeft: "140px" }}></td>
                                        {/*  <td style={{ border: "1px solid #ddd", padding: "8px", textAlign: "center"}}>
    <button
      className="action-btns k-grid-edit-command"
      onClick={() => handleEditAgent(counter)}
    >
      <EditIcon />
    </button>
  </td> */}
                                    </tr>
                                ))}
                            </React.Fragment>
                        ))}
                    </tbody>
                </table></>
           ) }

        </div>
    );
};

export default CardOrderPage;
